module.exports = __webpack_public_path__ + "img/Transfer3Page.b92e4ab0.png";